import { Stack } from '@mui/material';

import { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';

import { ReactComponent as CalenderIcon } from '../../../common/assets/images/calendar.svg';
import DatepickerComponent from '../../../common/components/Datepicker/Datepicker';

import styles from './UserManagement.module.scss';

interface IGRoupEndDateProps {
	data: any;
	handleGropuDateChange: (val: string, data: any) => void;
}

const GroupEndDate = (props: IGRoupEndDateProps) => {
	const { data, handleGropuDateChange } = props;
	const [isOpen, setCalendar] = useState<boolean>();

	const onDateChange = (val: any) => {
		handleGropuDateChange(val, data);
	};

	return (
		<div data-testid="grp-end-date">
			{data.isOpen ? (
				<Stack direction="row">
					<ButtonComp
						onClick={() => {
							data.isOpen = false;
							setCalendar(true);
						}}
						btnType="tertiary"
						data-testid="select-btn"
						className={
							(styles['btn-text-transform'],
							styles['filter-btn'],
							styles['user-group-content-row-date-style'])
						}
						startIcon={<CalenderIcon className={styles['calendar-icon']} />}
					>
						Select
					</ButtonComp>
				</Stack>
			) : (
				<DatepickerComponent
					propType={{
						inputProps: {
							'data-testid': 'date-picker',
						},
					}}
					onChange={onDateChange}
					dateValue={data?.endDate}
					open={isOpen}
				/>
			)}
		</div>
	);
};

export default GroupEndDate;
